import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import {
  Add as AddIcon,
  Archive as ArchiveIcon,
  FilterList as FilterListIcon,
  RemoveRedEye as RemoveRedEyeIcon,
} from "@mui/icons-material";
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Divider as MuiDivider,
  Paper as MuiPaper,
  Typography,
  Button,
  CircularProgress,
  TextField,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  LinearProgress,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box, spacing } from "@mui/system";
import useAuth from "../../../hooks/useAuth";
import Grid from "@mui/system/Unstable_Grid";
import InputMask from "react-input-mask";
const Card = styled(MuiCard)(spacing);

const CardContent = styled(MuiCardContent)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function DataGridClientes() {
  let { getApi, admPostApi, admGetApi } = useAuth();
  const [listRowsList, setRowsList] = React.useState([]);
  const [loadingList, setLoadingList] = React.useState(true);

  const [page, setPage] = useState(0);
  const [limitPage, setLimitPage] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);

  const [authenticating, setAuthenticating] = React.useState(false);

  const [arrayResult, setArrayResult] = React.useState([]);

  const AuthAsUser = async (general_business_account_id) => {
    setAuthenticating(true);
    let response = await admPostApi("/bsaccount/auth", {
      general_business_account_id: general_business_account_id,
    });

    window.open(response.url, "_blank").focus();
    setAuthenticating(false);
    return;
  };

  const navigate = useNavigate();

  const columns = [
    {
      field: "subject",
      headerName: "Assunto",
      width: 300,
      renderCell: (params: GridRenderCellParams<Date>) => (
        <React.Fragment>
          <Link>{params.row.subject ? params.row.subject : null}</Link>
        </React.Fragment>
      ),
    },
    {
      field: "company_name",
      headerName: "Razão Social",
      sortable: false,
      width: 200,
    },
    {
      field: "operator_name",
      headerName: "Criado por",
      sortable: false,
      width: 140,
    },
    {
      field: "consultant",
      headerName: "Consultor",
      sortable: false,
      width: 140,
    },
    {
      field: "status_name",
      headerName: "Status",
      sortable: false,
      width: 140,
    },

    {
      field: "created_at",
      headerName: "Ultima Atualização",
      sortable: false,
      width: 180,
      renderCell: (params: GridRenderCellParams<Date>) => (
        <React.Fragment>
          {new Date(params.row.last_update).toLocaleDateString("pt-br", {
            style: "currency",
            currency: "BRL",
          }) +
            " " +
            new Date(params.row.last_update).toLocaleTimeString("pt-br", {
              style: "currency",
              currency: "BRL",
            })}
        </React.Fragment>
      ),
    },

    {
      field: "action",
      headerName: "Ação",
      sortable: false,
      width: 180,
      renderCell: (params: GridRenderCellParams<Date>) => (
        <React.Fragment>
          <Link href={"/digital-account/tickets/id/" + params.row.id}>
            <Button
              variant="contained"
              size="small"
              tabIndex={params.hasFocus ? 0 : -1}
            >
              Visualizar
            </Button>
          </Link>

          <Link></Link>
        </React.Fragment>
      ),
    },
  ];

  const [activityList, setAcitivtyList] = useState([]);
  const [listMonthlyBilling, setListMonthlyBilling] = useState([]);

  const [listAccountType, setListAccountType] = useState([]);

  const [search_Status, setSearchStatus] = useState(-1);
  const [searchText, setSearchText] = useState(null);
  const [query_type, setQueryType] = useState("general_business_account_id");
  const [query_filterDateType, setQuery_filterDateType] = useState(1);

  const [query_filterDateStart, setQuery_filterDateStart] = useState(null);
  const [query_filterDateEnd, setQuery_filterDateEnd] = useState(null);
  const [statusList, setStatusList] = useState([]);

  const LoadStatus = async () => {
    let response = await admGetApi("/tickets/status", {});
    setStatusList(response);
  };

  function LoadQueryParams(limit_arg, page_arg) {
    let bsQuery = {};

    bsQuery["limit"] = limit_arg;
    bsQuery["page"] = page_arg;
    bsQuery["minimal_data"] = false;

    bsQuery["queryString"] = {
      BusinessAccount: {
        filterdatevalue: {},
      },
      AccountRequest: {},
      OperatorsUser: {},
      BusinessAccountable: {},
    };

    if (query_type) {
      bsQuery["queryString"]["AccountRequest"][query_type] = searchText;
    }

    if (statusId) {
      bsQuery["queryString"]["AccountRequest"]["account_requests_status_id"] =
        statusId;
    }

    return bsQuery;
  }

  useEffect(() => {
    LoadStatus();
    LoadTickets(0, 5);
  }, []);

  const [statusId, setStatusId] = React.useState();

  const LoadTickets = async (page_arg = null, limit_arg = null) => {
    setRowsList([]);
    setLoadingList(true);
    console.log(page_arg);
    let Arrayp = LoadQueryParams(
      limit_arg != null ? limit_arg : limitPage,
      page_arg != null
        ? page_arg == 0
          ? page_arg
          : page_arg
        : page == 0
        ? page
        : page
    );
    let response = await admPostApi("/tickets/lists", Arrayp);
    console.log(response.lista);

    setPage(response.page);
    setLimitPage(response.limit);
    setTotalRecords(response.total);
    FillArrayResult(response.lista.map((x) => x.ticket));
    setLoadingList(false);
  };

  const FillArrayResult = (data) => {
    let arrayTMP = [];
    data.forEach(function (curr, index, array) {
      arrayTMP.push({
        id: curr["id"],
        type_name: curr["type"]["name"],
        status_name: curr["status"]["name"],
        created_at: curr["created_at"],
        updated_at: curr["updated_at"],
        priority: curr["priority"],
        subject: curr["subject"],

        company_name: curr["bsaccount"]["company_name"],
        fantasy_name: curr["bsaccount"]["fantasy_name"],
        identifier: curr["bsaccount"]["identifier"],
        consultant: curr["bsaccount"]["consultant"],

        operator_name: curr["operator"]["fullname"],
        operator_email: curr["operator"]["email"],
        last_update:curr["last_update"],
      });
      setRowsList(arrayTMP);
    });
  };

  return (
    <Card mb={6}>
      <CardContent pb={1}></CardContent>
      <Typography variant="h6" gutterBottom>
        Procurar
      </Typography>
      <Grid container spacing={6}>
        <Grid item md={6}>
          <TextField
            id="query"
            placeholder={"Campo de busca"}
            variant="outlined"
            fullWidth
            my={2}
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Grid>
        <Grid item md={4}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Tipo de pesquisa
            </InputLabel>
            <Select
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={"Tipo de pesquisa"}
              value={query_type}
              onChange={(e) => setQueryType(e.target.value)}
            >
              <MenuItem value={"identifier"}>CPF/CNPJ envolvidos</MenuItem>
              <MenuItem value={"general_business_account_id"}>
                Código da conta de negócio
              </MenuItem>
              <MenuItem value={"operator_name"}>Nome do envolvido</MenuItem>
              <MenuItem value={"operator_email"}>E-mail do envolvido</MenuItem>
              <MenuItem value={"subject"}>Assunto</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item md={4}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={"Status"}
              value={statusId}
              onChange={(e) => setStatusId(e.target.value)}
            >
              {statusList &&
                statusList.map((row) => (
                  <MenuItem value={row.account_requests_status_id}>
                    {row.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container spacing={6}>
        <Grid item md={2}>
          <TextField
            id="query"
            label={"Data Inicial"}
            variant="outlined"
            fullWidth
            type="date"
            focused={true}
            onChange={(e) => setQuery_filterDateStart(e.target.value)}
            value={query_filterDateStart}
          />
        </Grid>
        <Grid item md={2}>
          <TextField
            id="query"
            label={"Data Final"}
            variant="outlined"
            fullWidth
            type="date"
            focused={true}
            onChange={(e) => setQuery_filterDateEnd(e.target.value)}
            value={query_filterDateEnd}
          />
        </Grid>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        mt={3}
        onClick={(e) => LoadTickets(0)}
      >
        Pesquisar
      </Button>

      <Divider my={6} />
      <Paper>
        <div style={{ height: limitPage == 5 ? 400 : 600, width: "100%" }}>
          <DataGrid
            rowsPerPageOptions={[5, 10, 25]}
            rows={listRowsList}
            columns={columns}
            pageSize={limitPage}
            rowCount={totalRecords}
            page={page}
            onPageSizeChange={(e) => {
              LoadTickets(null, e);
            }}
            paginationMode={"server"}
            onPageChange={(e) => {
              LoadTickets(e, null);
            }}
            loading={loadingList}
            getRowHeight={() => "auto"}
          />
        </div>
      </Paper>
    </Card>
  );
}

function TicketLists() {
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([]);

  const handleClose = (value) => {
    ShowModalFunc(null);
  };

  let { getApi, postApi, ShowModalFunc, showModal, isInitializedBS } =
    useAuth();

  return (
    <React.Fragment>
      <Helmet title="Contas de Negócios" />
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Tickets
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/">
              Dashboard
            </Link>
            <Link component={NavLink} to="/cobrancas">
              Tickets
            </Link>
            <Typography>Listagem</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Divider my={6} />

      <DataGridClientes />
    </React.Fragment>
  );
}

export default TicketLists;
